import { AppShell, AuthShell } from '@/components/AppShell';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/lib/auth';
import { ArrowLeft, Compass } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * SPA catchall — replaces the previous silent redirect-to-home so users
 * who land on a typo or stale link see something explanatory.
 */
export function NotFoundPage() {
  const { me } = useAuth();
  const isSignedIn = !!me?.user;
  const home = isSignedIn ? '/' : '/login';

  const body = (
    <Card>
      <CardContent className="space-y-4 py-10 text-center">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-brand-soft text-brand">
          <Compass className="size-6" />
        </div>
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
          404 · not found
        </p>
        <h1 className="text-2xl font-semibold tracking-tight">That page doesn&apos;t exist.</h1>
        <p className="mx-auto max-w-sm text-sm text-muted-foreground">
          The link is wrong, the page moved, or you bookmarked something we removed.
        </p>
        <div className="flex justify-center">
          <Button asChild>
            <Link to={home}>
              <ArrowLeft className="size-4" />
              {isSignedIn ? 'Back to your workspace' : 'Back to sign in'}
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );

  if (isSignedIn) {
    return <AppShell width="md">{body}</AppShell>;
  }
  return <AuthShell>{body}</AuthShell>;
}
